import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=5347af86&scoped=true&"
import script from "./Requests.vue?vue&type=script&lang=ts&"
export * from "./Requests.vue?vue&type=script&lang=ts&"
import style0 from "./Requests.vue?vue&type=style&index=0&id=5347af86&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347af86",
  null
  
)

export default component.exports